import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { User } from '../models/user';
import { Http } from '@angular/http';
import util from '../util';

@Injectable({
  providedIn: 'root'
})
export class SocioService {
  urlAPI = util.api; // api rest fake
  constructor(
    private httpClient: HttpClient,
    ) { }

  httpOptions = {
    headers: new HttpHeaders({ 'Content-Type': 'application/json' })
  }
  verificarSocio(id){    
    let res = this.httpClient.get<User>(this.urlAPI + 'socio/pegar/'+id,{observe: 'response'})
    .toPromise().then((res)=>{
      return res
    }).catch((err)=>{
      return err
    })
        return res
  }
  getociosano(ano){    
    let res = this.httpClient.get<User>(this.urlAPI + 'socio/doAno/'+ano,{observe: 'response'})
    .toPromise().then((res)=>{
      return res
    }).catch((err)=>{
      return err
    })
        return res
  }
  listarSociosValidos(){    
    let res = this.httpClient.get<User>(this.urlAPI + 'socio/listarSocioValidos',{observe: 'response'})
    .toPromise().then((res)=>{
      return res
    }).catch((err)=>{
      return err
    })
        return res
  }
  listarSociosValidosHistorico(){    
    let res = this.httpClient.get<User>(this.urlAPI + 'socio/listarSocioValidosHistorico',{observe: 'response'})
    .toPromise().then((res)=>{
      return res
    }).catch((err)=>{
      return err
    } )
        return res
  }


  indiplentes(){
    let res = this.httpClient.get<User>(this.urlAPI + 'socio/inadiplentes/3',{observe: 'response'})
    .toPromise().then((res)=>{
      return res
    }).catch((err)=>{
      return err
    })
        return res
  }
  private handleError(error: any): Promise<any> {
    console.error('An error occurred', error); // for demo purposes only
    return Promise.reject(error.message || error);
  }
}
